import { Stack } from "@mui/system";
import MDBox from "components/MDBox";
import BillzTypography from "../BillzTypographies/BillzTypography";

export default function ContractorSummaryPanel(props) {
    const data = props.data;

    function isNotEmpty(value) {
        return value != null && value != undefined && value != '';
    }

    function getAddressLine(data) {
        const test = '';
        return data.address.street +
            (isNotEmpty(data.address.houseNumber) ? (' ' + data.address.houseNumber) : '') +
            (isNotEmpty(data.address.apartmentNumber) ? ('/'+data.address.apartmentNumber) : '') + 
            (isNotEmpty(data.address.zipCode) ? (', '+data.address.zipCode) : '') +
            (isNotEmpty(data.address.city) ? ((isNotEmpty(data.address.zipCode) ? ' ' : ', ') +data.address.city) : '');
    }

    return (
        <MDBox sx={props.sx}>
            <Stack>
                <BillzTypography color='text'>{data.name}</BillzTypography>
                <BillzTypography color='text'>NIP: {data.nip.nip}</BillzTypography>
                <BillzTypography color='text'>{getAddressLine(data)}</BillzTypography>
            </Stack>
        </MDBox>
    )
}